import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.273,
	height: 13.273,
	viewBox: "0 0 13.273 13.273",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "status_icon",
		"data-name": "status icon",
		transform: "translate(-326 -2886.828)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Icon_feather-target",
			"data-name": "Icon feather-target",
			transform: "translate(323.5 2884.328)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_3673",
				"data-name": "Path 3673",
				d: "M15.273,9.137A6.137,6.137,0,1,1,9.137,3a6.137,6.137,0,0,1,6.137,6.137Z",
				transform: "translate(0)",
				fill: "none",
				stroke: "#0473a9",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_3720",
			"data-name": "Path 3720",
			d: "M10.527,10.858a.608.608,0,0,0-1.045,0l-1.81,3.626-.648-1.291a.577.577,0,0,0-.52-.321H3v1.168H6.142l1,2.015a.592.592,0,0,0,.526.321.577.577,0,0,0,.52-.321l1.816-3.626.648,1.291a.577.577,0,0,0,.52.321h3.5V12.873H11.538l-1.01-2.015Z",
			transform: "translate(323.772 2879.998)",
			fill: "#0473a9"
		})]
	})
});
export default SvgStatusIcon;
